<script>
export default {
  methods: {
    getRawValue(value) {
      return String(value).replace(/\D/g, '');
    },
    getFormattedValue(value) {
      const rawValue = this.getRawValue(value);
      return new Intl.NumberFormat(this.$fischer.siteLanguage()).format(rawValue);
    },
  },
};
</script>
